export const MIXPANEL_EVENTS = {
  BEGIN_REGISTER_CLICK: "BEGIN_REGISTER_CLICK",
  WHATSAPP_CHAT_CLICK: "WHATSAPP_CHAT_CLICK",

  // navigation
  VIEW_STEP: "VIEW_STEP",
  NEXT_STEP_CLICK: "NEXT_STEP_CLICK",
  PREV_STEP_CLICK: "PREV_STEP_CLICK",

  // products
  ADD_PRODUCT_CLICK: "ADD_PRODUCT_CLICK",
  EDIT_PRODUCT_CLICK: "EDIT_PRODUCT_CLICK",
  SAVE_PRODUCT_CLICK: "SAVE_PRODUCT_CLICK",
  SAVE_PRODUCT_SUCCESS: "SAVE_PRODUCT_SUCCESS",
  SAVE_PRODUCT_ERROR: "SAVE_PRODUCT_ERROR",
  DELETE_PRODUCT_CLICK: "DELETE_PRODUCT_CLICK",
  DELETE_PRODUCT_SUCCESS: "DELETE_PRODUCT_SUCCESS",
  DELETE_PRODUCT_ERROR: "DELETE_PRODUCT_ERROR",

  // password
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_ERROR: "CHANGE_PASSWORD_ERROR",

  // send form events
  COMPLETE_FORM_CLICK: "COMPLETE_FORM_CLICK",
  KEEP_EDITING_CLICK: "KEEP_EDITING_CLICK",
  COMPLETE_FORM_SUCCESS_CLICK: "COMPLETE_FORM_SUCCESS_CLICK",
  COMPLETE_FORM_ERROR: "COMPLETE_FORM_ERROR",

  // after sending form, results
  ONBOARDING_COMPLETED_WITH_NO_REGION: "COMPLETE_ONBOARDING_NO_REGION",
  ONBOARDING_COMPLETED_SUCCESS: "ONBOARDING_COMPLETED_SUCCESS",
};
